import SwapConfirmation from './SwapConfirmation';

export default SwapConfirmation;
